module.exports = __webpack_public_path__ + "img/value_mock.92182253.png";